__turbopack_context__.v({
  "btn": "DevBannerToggle-module__PLxXaq__btn",
});
